import { PaymentRailType } from '@/types/currency';
import { TransactionResponse } from '@/types/transaction';
import { isPixInLocalInfo } from '@/types/transaction.ext';

export const transactionResponseToNavigationState = (
  response: TransactionResponse,
  fundingMethod: PaymentRailType,
): any => {
  const { localInfo } = response;

  if (isPixInLocalInfo(localInfo)) {
    return {
      data: localInfo.pixCopyAndPaste,
      fundingMethod: fundingMethod,
    };
  } else {
    return {
      fundingMethod: fundingMethod,
      transactionId: response.id,
    };
  }
};
